import { render, staticRenderFns } from "./CopySyllabusModal.vue?vue&type=template&id=8c8da788&"
import script from "./CopySyllabusModal.vue?vue&type=script&lang=js&"
export * from "./CopySyllabusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports